export default __webpack_public_path__ + "static/feedback-bd50369aec5733559b04c5cf5063f28f.jpg";